
function mcardSwap(productId, imgUrl, clickedEl) {
// Remove active state from all swatches of this product
document.querySelectorAll('.mcard-product-' + productId + ' .ucard-swatch, product-card[handle] .ucard-swatch').forEach(el => {
    el.style.outline = 'none';
});

// Find THIS product card's swatches and reset them
const card = clickedEl.closest('product-card');
if (card) {
    card.querySelectorAll('.ucard-swatch').forEach(el => el.style.outline = 'none');
    clickedEl.style.outline = '1px solid black';

    // Swap the main image
    const img = card.querySelector('.mcard-image-' + productId);
    if (img) {
    img.src = imgUrl;
    img.srcset = imgUrl;
    }
}
}
